import { faCircle } from "@jewlr/pro-solid-svg-icons/faCircle"
import { faDiamond } from "@jewlr/sharp-solid-svg-icons/faDiamond"

import { jewlr_t } from "helpers/application"

import ConfettiCard from "./confetti-card"

const coverageData = [
  {
    children: (
      <>
        <p className="body mb-16">
          While we value attention to detail, occasional slips can happen. Our
          warranty includes:
        </p>
        <ul className="m-0">
          <li>
            <p className="body">
              <b>Manufacturing defects</b> like metal, gemstone, or setting
              issues
            </p>
          </li>
          <li>
            <p className="body">
              <b>Craftsmanship problems</b> affecting durability or
              functionality
            </p>
          </li>
          <li>
            <p className="body">
              <b>Damage during shipping or transit</b>
            </p>
          </li>
        </ul>
      </>
    ),
    className: "bg-[#96b22c1a] border-peridot",
    icon: faDiamond,
    iconClassName: "text-peridot",
    title: "What Is Covered",
  },
  {
    children: (
      <>
        <p className="body mb-16">
          Our warranty does not extend to everyday wear and tear. Here&apos;s
          what&apos;s not included:
        </p>
        <ul className="m-0 pl-16">
          <li>
            <p className="body">
              <b>Normal wear</b> such as scratches, dents, and dis
              {jewlr_t("terms.color")}ation
            </p>
          </li>
          <li>
            <p className="body">
              <b>Tarnishing of silver or plated {jewlr_t("terms.jewelry")}</b>{" "}
              &ndash; this is a natural process
            </p>
          </li>
          <li>
            <p className="body">
              <b>Damage from accidents, improper care, or misuse</b>
            </p>
          </li>
          <li>
            <p className="body">
              <b>Loss or theft of the {jewlr_t("terms.jewelry")}</b>
            </p>
          </li>
          <li>
            <p className="body">
              <b>Third-party alterations or repairs</b>
            </p>
          </li>
        </ul>
      </>
    ),
    className: "bg-[#e3352a1a] border-ruby",
    icon: faCircle,
    iconClassName: "text-ruby",
    title: "What’s Not Covered",
  },
]

const Coverage = () => {
  return (
    <div className="desktop:gap-40 desktop:grid-cols-2 desktop:mb-60 mb-32 grid grid-cols-1 gap-16">
      {coverageData.map((data, i) => (
        <ConfettiCard key={i} {...data} />
      ))}
    </div>
  )
}

export default Coverage
